import { VALIDATION_ABORT, VALIDATION_START, VALIDATION_REQUEST, VALIDATION_DATE_CHECK_FAILURE } from '../types';

export const abortValidation = () => ({ type: VALIDATION_ABORT });

export const startValidation = () => ({ type: VALIDATION_START });

export const sendValidation = (code, bookingId) => ({ type: VALIDATION_REQUEST, payload: { bookingId, code } });

export const failValidationDateCheck = (err) => ({ type: VALIDATION_DATE_CHECK_FAILURE, payload: err });
